export default "__VITE_ASSET__52ef8743__"